import Vue from 'vue';
import Hotjar from 'vue-hotjar';
import getEnvVar from 'helper/envHelper';

Vue.use(Hotjar, {
  id: '2223361',
  isProduction: getEnvVar('ENABLE_HOTJAR') === 'true' ? true : false,
});
